import { TableHeaderConfig } from '../../../components/_EOS/Table'
import { FilterOption } from '../../../components/_WMS/FilterComponent'
import { object, string, number } from 'yup'
import { renderOrigins } from '../Components/index'

const filterOptions: FilterOption[] = [
  { key: 'origin', label: 'Origen', order: 1, type: 'text' },
  { key: 'name', label: 'Marca', order: 2, type: 'text' }
]

const headersConfig: TableHeaderConfig[] = [
  { field: 'origin', title: 'Origen', sortable: true },
  { field: 'name', title: 'Marca', sortable: true },
  {
    field: 'orderOriginNames',
    title: 'Origenes',
    formater: (value) => renderOrigins(value)
  },
  {
    field: 'typeStorageName',
    title: 'Tipo de Almacenamiento',
    sortable: false
  },
  {
    field: 'hasExpirationDays',
    title: 'Estado (Fefo)',
    sortable: false
  },
  {
    field: 'expirationDays',
    title: 'Tolerancia en días de Picking FEFO',
    formater: (value) => (value === null ? 'Sin Configurar' : value),
    sortable: false
  }
]

export const productOriginValidationSchema = object({
  origin: string()
    .required('Debe ingresar un origen')
    .min(1, 'Debe ingresar al menos 1 caracter')
    .max(50, 'Debe ingresar como máximo 50 caracteres')
    .matches(
      /^[a-z0-9]+$/,
      'origen requiere minúsculas o números, sin espacios al principio y al final'
    ),
  name: string()
    .trim()
    .required('El campo marca es requerido.')
    .min(1, 'Debe ingresar al menos 1 caracter')
    .max(200, 'Máximo 200 caracteres.'),
  typeStorageId: number()
    .required('Debe seleccionar el tipo de almacenamiento.')
    .oneOf([1, 2, 3], 'Debe seleccionar tipo de almacenamiento externo.')
})

export { filterOptions, headersConfig }
